import { ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';

export abstract class MeValidation {
  validators!: ValidatorFn;
  validationType: string;
  public hasEndingPeriod: boolean = true;

  constructor(public translate: TranslateService | TranslateUtilityService, validationType: string) {
    this.validationType = validationType;
  }

  getValidator(): ValidatorFn {
    return this.validators;
  }

  abstract getErrorMessage(): string;

  getValidationType(): string {
    return this.validationType;
  }
}
